"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shapes = void 0;
exports.shapes = ['straight', 'corner', 'u-shape'];
